// extracted by mini-css-extract-plugin
export default {"link":"DI-z","disabled":"EI-z"};